export default function formatDisplayDate(dateParams = {}) {
  const options = {};

  if (dateParams.timezone) {
    options.timeZone = dateParams.timezone;
  }

  if (!dateParams.date.includes("T")) {
    return new Date(dateParams.date).toLocaleDateString(
      navigator?.language || "en-US",
      options
    );
  }

  return new Date(dateParams.date).toLocaleString(
    navigator?.language || "en-US",
    options
  );
}
